
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/browse/company",
      function () {
        return require("private-next-pages/browse/company.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/browse/company"])
      });
    }
  